import React, { useEffect, useState, useRef, useContext, useCallback } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { userActions, work_spaceActions, organizationActions } from "../../../actions";
import { WorkspaceInlineEdit } from '../../../components/WorkspaceInlineEdit.js';
import { Navbar, NavDropdown, Button, Dropdown, Row, Col, Spinner, Image } from "react-bootstrap";
import { adminBaseURL } from "../../../utils/commonUtils";
import { useMediaQuery } from 'react-responsive';
import { history } from '../../../helpers';
import '../../stylesheets/workspace_page-show.scss';
import WorkSpaceEdit from '../WorkSpacePage/edit';
import WorkspaceUsersPopup from '../CollaboratorPage/list';
import { Popup, UserThumbnails, ElementTooltip, PopupAlert } from '../../../components';
import { tooltipConstants } from '../../../constants';
import WorkspaceSearchBar from '../../../components/WorkspaceSearchBar';
import { WorkspaceBarContext } from '../../../contexts/WorkspaceBarContext';
import { matchPath } from 'react-router';
import DropdownIcon from '../../../images/icons/dropdown-arrow.svg';
import useLeaveWorkspaceHooks from "../../../hooks/useLeaveWorkspaceHooks.js";
import FlatThreeDot from "../../../components/icons/FlatThreeDot.js";

function WorkspaceBar(props) {
  const {
          workspace_id,
          workspace_view,
          currentWorkspace,
          can_invite_collaborator,
          can_access_workspace,
          can_access_user_add_invite,
          contentGroupPopUp,
          workspaces,
          loading,
          show
  } = props
  const dispatch = useDispatch();
  const workspaceBaseUrl = adminBaseURL("workspaces");
  const work_space_error = useSelector(state => state.work_space);
  const [view, setView] = useState("list");
  const { workspaceBarRef } = useContext(WorkspaceBarContext)
  const [deletePopup, setDeletePopup] = useState({
    show: false,
    id: null,
  });
  const location = useLocation();
  const params =  matchPath(location.pathname, { path: workspaceBaseUrl+"/:workspace_id", strict: false, exact: false })
  const [workspace_logo_cached, setWorkspaceLogoCached] = useState(false);
  const [workspace_logo, setWorkspaceLogo] = useState();
  const [workspace_dropdown_cached, setWorkspaceDropdownCached] = useState(false);
  const { 
    leaveWorkspacePopupData,
    handleCloseLeaveWorkspacePopup, 
    handleOpenLeaveWorkspacePopup 
  } = useLeaveWorkspaceHooks();

  const [popupEditForm, setPopUpEditForm] = useState({
    show: false,
    id: null
  });;

  const handleCloseEditForm = () => {
    //setPopUpEditForm({ show: false, id: null });
    window.location.reload();
  }

  const [showWorkspaceUsersPopup, setShowWorkspaceUsersPopup] = useState({
    show: false,
    id: null
  });

  const handleShowWorkspaceUsersPopup = (id) => {
    setShowWorkspaceUsersPopup({ show: true, id: id })
  }

  const handleCloseWorkspaceUsersPopup = () => {
    setShowWorkspaceUsersPopup({ show: false, id: null })
  }

  useEffect(() => {
    if (!!workspace_id) {
      handleClickTab(workspace_id, workspace_view || "list");
    }
  }, [workspace_id]);

  useEffect(() => {
    if(currentWorkspace?.logo?.thumb_url){
      setWorkspaceLogo(currentWorkspace?.logo?.thumb_url);
      setWorkspaceLogoCached(true);
    }
  }, []);


  useEffect(() => {

    if(workspace_logo_cached){
      return;
    }

    if (currentWorkspace?.logo?.thumb_url) {
      setWorkspaceLogo(currentWorkspace?.logo.thumb_url);
      setWorkspaceLogoCached(true);
    }

  }, [currentWorkspace?.logo]);

  useEffect(() => {
    if(workspace_dropdown_cached){
      return;
    }
    if(currentWorkspace){
      let serializer_type = 'list'

      dispatch(organizationActions.getWorkspaces(currentWorkspace.organization_id, serializer_type))

      setWorkspaceDropdownCached(true);
    }
  }, [currentWorkspace]);

  const handleClickTab = (workspace_id, view) => {
    let noReload = false
    dispatch(work_spaceActions.setWorkspaceView(workspace_id, view, noReload));
  }

  const handleShowEditForm = (id) => {
    dispatch(work_spaceActions.editWorkSpace(id, setPopUpEditForm));
  }

  const handleShowDeletePopup = (id) => setDeletePopup({ show: true, id });

  const handleDelete = () => {
    dispatch(work_spaceActions.destroyWorkSpace(deletePopup.id));
    setDeletePopup({ show: false, id: null });
  }


  const handleCloseDeletePopup = (handleDelete) => {
    setDeletePopup({ show: false, id: null });
  }

  const handleInlineEdit = (handleOnBlur, values, workspace_id) => {
    dispatch(work_spaceActions.inlineEditWorkspace(handleOnBlur, values, workspace_id));
  }

  const sorted_workspaces = workspaces?.sort((a, b) => a.name.localeCompare(b.name)).filter(w => w.id !== currentWorkspace?.id);

  const handleWorkspaceDropDownToggle = (open) => {
    if(sorted_workspaces.length === 0) {
      return
    }
    if(open) {
      let serializer_type = 'list'

      dispatch(organizationActions.getWorkspaces(currentWorkspace.organization_id, serializer_type))
    }
  }

  const handleLeaveWorkspace = useCallback(() => {
    const finallyFunc = () => {
      handleCloseLeaveWorkspacePopup();
    };

    const successFunc = () => {
      history.push('/');
    };

    dispatch(work_spaceActions.leaveWorkspace(leaveWorkspacePopupData.id, successFunc, finallyFunc));

  }, [dispatch, leaveWorkspacePopupData.id, handleCloseLeaveWorkspacePopup]);

  const has_many_workspaces = sorted_workspaces && sorted_workspaces.length > 0;

  return (
    <div className={show ? '' : `d-none`}>
      <div className={`workspace_page-title py-1`} ref={workspaceBarRef}>
          <div className="workspace-bar__details-wrapper px-2">
            <div className="workspace_title d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                { workspaces && workspaces.length > 0 &&
                  <NavDropdown
                    title={
                      <>
                        { workspace_logo &&
                          <img
                            src={workspace_logo}
                            className="workspace_thumbnail_logo"
                          />
                        }
                        <div className="d-flex align-items-center">
                          <span className="dropdown-toggle__text h4 mb-0 font-weight-bold mr-3 text-truncate">
                            { currentWorkspace?.name }
                          </span>

                          {
                            sorted_workspaces.length > 0 &&
                            <Image src={DropdownIcon} width='8' height="8" />
                          }  
                        </div>
                      </>
                    }
                    id="basic-nav-dropdozwn"
                    onToggle={handleWorkspaceDropDownToggle}
                    className={`workspace_bar-dropdown ${has_many_workspaces ? '' : 'workspace_bar-dropdown__no-workspace border-0 bg-transparent' }`}
                    disabled={sorted_workspaces.length === 0}
                  >

                    {
                        sorted_workspaces.map((data, index) => (
                          <NavDropdown.Item
                            key={index}
                            href={`/organizations/${data.organization_id}`+workspaceBaseUrl + "/" + data.id + "/list"}
                            className="text-truncate"
                          >
                            {
                              data.logo && data.logo.thumb_url &&
                              <img
                                src={data.logo.thumb_url}
                                title={data.name}
                                alt={data.name}
                                height={32}
                                className={"mr-3"}
                              />
                            }

                            <span className="dropdown-item__text text-truncate">{data.name}</span>
                          </NavDropdown.Item>
                        ))
                    }
                    { loading && sorted_workspaces.length > 1 &&
                      <div className="spinner-container">
                        <Spinner animation="border" />
                      </div>
                    }
                  </NavDropdown>
                }


                &nbsp;

                <div className="workspace-bar__users-wrapper" onClick={() => can_access_user_add_invite ? handleShowWorkspaceUsersPopup(currentWorkspace?.id) : null}>
                  <UserThumbnails
                    users={currentWorkspace?.workspace_users}
                    limit={6}
                    tooltip={true}
                    disable_users_info={true}
                    className={'cursor-pointer'}
                    avatarBorderColor={'#E9E8F5'}
                  />
                </div>
              </div>

              <div className="workspace_page-button-group bg-white rounded-pill">
                <Button onClick={() => handleClickTab(currentWorkspace?.id, "list")} className={`px-2 rounded-pill ${workspace_view == 'list' ? 'active' : '' }`}>List</Button>
                <Button onClick={() => handleClickTab(currentWorkspace?.id, "board")} className={`px-2 rounded-pill ${workspace_view == 'board' ? 'active' : '' }`}>Board</Button>
                <Button onClick={() => handleClickTab(currentWorkspace?.id, "calendar")} className={`px-2 rounded-pill ${workspace_view == 'calendar' ? 'active' : '' }`}>Calendar</Button>
              </div>


              <div className="d-flex align-items-center">
                <WorkspaceSearchBar />
                {currentWorkspace && (currentWorkspace.can_access_update_workspace || currentWorkspace.can_access_destroy_workspace || currentWorkspace.can_access_leave_workspace) && (
                  <Dropdown className="">
                    <Dropdown.Toggle variant="primary" id="dropdown-basic" className="btn-transparent d-flex align-items-center" title="Options">
                      <FlatThreeDot />
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{right: "auto"}}>
                      {
                        currentWorkspace.can_access_update_workspace &&
                        <Button 
                          onClick={() => handleShowEditForm(currentWorkspace.id)} 
                          variant="secondary" 
                          className="dropdown-item"
                          size="sm"
                        >
                          Settings
                        </Button>
                      }
                      {
                        currentWorkspace.can_access_leave_workspace &&
                        <Button 
                          onClick={() => handleOpenLeaveWorkspacePopup(currentWorkspace.id)} 
                          variant="secondary" 
                          className="dropdown-item"
                          size="sm"
                        >
                          Leave Workspace
                        </Button>
                      }
                      {
                        currentWorkspace.can_access_destroy_workspace &&
                        <Button 
                          onClick={() => handleShowDeletePopup(currentWorkspace.id)} 
                          variant="secondary" 
                          className="dropdown-item"
                          size="sm"
                        >
                          Delete
                        </Button>
                      }
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </div>
            </div>
          </div>
      </div>

      {
        showWorkspaceUsersPopup.show &&
        <WorkspaceUsersPopup
          workspaceId={showWorkspaceUsersPopup.id}
          handleClose={handleCloseWorkspaceUsersPopup}
        />
      }
      {
        popupEditForm.show &&
        <WorkSpaceEdit
          workspace_id={popupEditForm.id}
          handleCloseEditForm={handleCloseEditForm}
          work_space_error={work_space_error}
        />
      }

      {
        deletePopup.show &&
        <Popup
          handleClose={handleCloseDeletePopup}
          handleDelete={handleDelete}
        />
      }

      {
        leaveWorkspacePopupData.show &&
          <PopupAlert
            show={leaveWorkspacePopupData.show}
            handleClose={handleCloseLeaveWorkspacePopup}
            handleSubmit={handleLeaveWorkspace}
            display_text={"Are you sure you want to leave this workspace?"}
            btn_text={"Leave"}
            hasClose
          />
      }
    </div>
  );
}


const mapStateToProps = (state) => {
  return {
    loading: state.work_space.workspace_dropdown_loading,
    workspaces: state.work_space.work_spaces,
    currentWorkspace: state.work_space.currentWorkSpace,
    workspace_view: state.work_space.workspaceView,
    can_access_workspace: state.work_space.can_access_workspace,
    can_access_user_add_invite: state.work_space.can_access_user_add_invite
  };
};

export default connect(mapStateToProps, { userActions })(WorkspaceBar);
